<div class="pme-container" >
    <div class="display-utils-col display-utils-gt-sm-row display-utils-center">
      <div *ngIf="this.heroData && this.heroData.title !== 'Cancelamento de plano'" class="pme-col display-utils-gt-sm-flex-50">
        <pme-hero *ngIf="this.showHero" type="{{this.heroData.type}}" title="{{this.heroData.title}}"
          showButton="{{this.heroData.showButton}}" buttonName="{{this.heroData.buttonName}}"
          redirectURL="{{this.heroData.redirectURL}}">
          <p *ngFor="let content of this.heroData.contents">{{content}}</p>
        </pme-hero>
      </div>
    </div>

    <div class="product-choice-mobile" *ngIf="isMobile && showRetention">
      <aside>
        <div *ngIf="this.showForm">
          <pme-product-choice style="width: 100%;" [cardTitle]="'Plano atual'" [changeText]="" [changeLink]=""
            [productName]="planName" [totalValue]="value" [description]="" [productNameBold]="true" [showPlanResume]="false">
            <hr class="divider">
            <div class="pme-product-choice-item mat-h3 display-utils-col display-utils-gap-1rem">
              <div class="display-utils-row display-utils-between-center">
                <div class="color-blue">Início da assinatura</div>
                <div class="pme-text-right color-blue">{{startDate}}</div>
              </div>
              <div class="display-utils-row display-utils-between-center">
                <div><b>Término da assinatura</b></div>
                <div class="pme-text-right"><b>{{endDate}}</b></div>
              </div>
            </div>
          </pme-product-choice>
        </div>
      </aside>
    </div>

    <div class="pme-row display-utils-col display-utils-gt-sm-row display-utils-center display-utils-gap-0 display-utils-gt-sm-gap-40" *ngIf="showRetention">
      <div class="display-utils-col" style="padding-bottom: 20px;" style="width: 100%;">
        <div class="title display-utils-col display-utils-start-left display-utils-flex-auto">
          <h1>Cancelamento de plano</h1>
          <p>
            Você continuará com o seu plano até {{endDate}} e cancelaremos todas as cobranças futuras.
          </p>
          <h2 *ngIf="showRetentionBenefits">Benefícios do {{ getPlanType() }} que você <strong>perderá ao cancelar sua assinatura:</strong></h2>
        </div>

        <div class="benefits-container display-utils-col" *ngIf="showRetentionBenefits">
          <pme-product-benefit 
            *ngFor="let benefit of benefits" 
            [title]="benefit.title" 
            [description]="benefit.description" 
            [iconUrl]="benefit.iconUrl">
          </pme-product-benefit>
        </div>

        <div class="retetion-discount-container display-utils-row display-utils-center-center" *ngIf="showRetentionDiscount">
          <div class="discount-left-icon">
            <img src="/assets/images/retentionDiscount.svg" alt="Ícone de desconto">
          </div>
  
          <div class="offer-details">
            <h3>Aproveite: <strong>{{retetionMessage}}</strong></h3>
            <div class="price-container">
              <p class="old-price">de <span class="price">R$ {{productValue}}</span></p>
              <p class="new-price">
                por 
                <span class="price-currency">R$</span> 
                <span class="price-value">{{productValueWithDiscount}}</span>
              </p>
            </div>            
          </div>
          
          <div class="discount-right-icon">
            <img src="/assets/images/retentionDiscount.svg" alt="Ícone de desconto">
          </div>
        </div>
        
        <div class="button-container">
          <button 
            mat-flat-button 
            class="pme-btn-lg cancel-button" 
            [disabled]="submitting" 
            (click)="cancelPlan()"
          >
            <div style="text-transform: none;">Confirmar cancelamento</div>
          </button>
        
          <button 
            mat-flat-button 
            class="pme-btn-lg continue-button" 
            [disabled]="submitting" 
            (click)="continuePlan()"
          >
            <div style="text-transform: none;">Continuar com o {{ getPlanType() }}</div>
          </button>
        </div>        
      </div>

      <div class="product-choice-desk" *ngIf="!isMobile">
        <aside>
          <div *ngIf="this.showForm">
            <pme-product-choice style="width: 100%;" [cardTitle]="'Plano atual'" [changeText]="" [changeLink]=""
              [productName]="planName" [totalValue]="value" [description]="" [productNameBold]="true" [showPlanResume]="false">
              <hr class="divider">
              <div class="pme-product-choice-item mat-h3 display-utils-col display-utils-gap-1rem">
                <div class="display-utils-row display-utils-between-center">
                  <div class="color-blue">Início da assinatura</div>
                  <div class="pme-text-right color-blue">{{startDate}}</div>
                </div>
                <div class="display-utils-row display-utils-between-center">
                  <div><b>Término da assinatura</b></div>
                  <div class="pme-text-right"><b>{{endDate}}</b></div>
                </div>
              </div>
            </pme-product-choice>
          </div>
        </aside>
      </div>
    </div>

</div>